import React from "react";
import { Button, Col, Form, Image, Modal, Row } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import FileDropZone from "../sub/FileDropZone";
import { connect } from "react-redux";
import {
  addProductFamily,
  addProductFamilyImage,
  isProductFamilyKeywordAlreadyExists,
  updateProductFamily,
} from "../../actions/imagedatabase/productsFamilies";
import APIUrl from "../../APIUrl";
import Icon from "../sub/Icon";
import KeywordModal from "./KeywordModal";
import ConfirmationModal from "../sub/modals/ConfirmationModal";
import Notification from "../sub/Notification";
import MenuButton from "../sub/bootstrap/MenuButton";
import UploadImgModal from "./UploadImgModal";

class FamilyModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      keyword: "",
      keywords: this.props.family ? this.props.family.keywords : [],
      keywordError: "",
      file: null,
    };
  }

  isKeywordAlreadyExists(keyword) {
    if (!keyword) return this.setState({ keywordError: "" });

    this.props.onGetIsProductFamilyKeywordAlreadyExists(
      keyword.toUpperCase(),
      () =>
        this.setState({
          keywordError: <FormattedMessage id="Keyword.Already.Exists" />,
        }),
      () => this.setState({ keywordError: "" }),
    );
  }

  closeModal() {
    this.setState({ modal: null });
  }

  addKeyword(newkeyword) {
    const updatedKeywords = [...this.state.keywords, newkeyword];
    this.setState({ keyword: "", keywords: updatedKeywords });
  }

  updateKeyword(oldKeyword, newkeyword) {
    const updatedKeywords = this.state.keywords
      .filter((k) => k !== oldKeyword)
      .concat(newkeyword);
    this.setState({ keywords: updatedKeywords });
  }

  deleteKeyword(keyword) {
    const updatedKeywords = this.state.keywords.filter((k) => k !== keyword);
    this.setState({ keywords: updatedKeywords });
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  openKeywordModal(keyword) {
    this.setState({
      modal: (
        <KeywordModal
          imageType={"family"}
          keyword={keyword}
          add={(newKeyword) => this.addKeyword(newKeyword)}
          update={(newKeyword) => this.updateKeyword(keyword, newKeyword)}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  uploadImg(familyId, img) {
    const successCallback = () => {
      Notification({
        type: "success",
        description: this.props.intl.formatMessage({
          id: "Image.Add.Success",
        }),
      });

      this.props.fetchProductsFamilies();
      this.props.closeModal();
    };
    let formData = new FormData();
    formData.append(img.name, img);

    this.props.onAddProductFamilyImage(familyId, formData, successCallback);
  }

  addFamily() {
    let family = {
      keywords: this.state.keywords,
    };

    if (this.props.family) {
      family._id = this.props.family._id;
      return this.props.onUpdateProductFamily(family, () => {
        if (this.state.file && this.state.file.length !== 0) {
          this.uploadImg(family._id, this.state.file[0]);
        }

        this.props.fetchProductsFamilies();
        this.props.closeModal();
      });
    }

    this.props.onAddProductFamily(family, (f) =>
      this.uploadImg(f._id, this.state.file),
    );
  }

  openImgModal(currentImage) {
    const onComplete = (newImage) => {
      this.setState({ file: newImage }, () => this.closeModal());
    };

    this.setState({
      modal: (
        <UploadImgModal
          closeModal={() => this.closeModal()}
          currentImage={currentImage}
          onComplete={onComplete}
        />
      ),
    });
  }

  render() {
    const { family } = this.props;

    let currentImage = null;

    if (family) {
      currentImage = this.state.file
        ? URL.createObjectURL(this.state.file[0])
        : `${APIUrl.getFamilyImg}${family._id}/?token=${APIUrl.jwtToken}`;
    }

    return (
      <Modal
        show={true}
        onHide={() => this.props.closeModal()}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {family ? `ID: ${family._id}` : <FormattedMessage id="Add.Image" />}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {family ? (
            <>
              <Row className="text-center">
                <Col>
                  <Image width={250} src={currentImage} thumbnail alt="" />
                </Col>
              </Row>
              <Row>
                <Col className="text-center mt-3">
                  <MenuButton
                    icon="upload"
                    size="sm"
                    onClick={() => this.openImgModal(currentImage)}
                  >
                    <FormattedMessage id="Modify" />
                  </MenuButton>
                </Col>
              </Row>
            </>
          ) : (
            <FileDropZone
              onDropFile={(file) => this.setState({ file: file })}
              acceptedExtensions={["jpg", "png", "jpeg", "webp"]}
              multiple={false}
            />
          )}
          <Form className="mt-3">
            <Form.Group>
              <Form.Label>
                <FormattedMessage id="Keyword" />
              </Form.Label>
              <Row>
                <Col md="10">
                  <Form.Control
                    type="text"
                    value={this.state.keyword}
                    isInvalid={this.state.keywordError !== ""}
                    onChange={(e) =>
                      this.setState({ keyword: e.target.value.toUpperCase() })
                    }
                    onBlur={() =>
                      this.isKeywordAlreadyExists(this.state.keyword)
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.keywordError}
                  </Form.Control.Feedback>
                </Col>
                <Col md="2">
                  <Button
                    variant="info"
                    disabled={
                      this.state.keyword.trim() === "" ||
                      this.state.keywordError
                    }
                    onClick={() =>
                      this.state.keyword.trim() !== "" &&
                      this.state.keywordError === "" &&
                      this.addKeyword(this.state.keyword)
                    }
                  >
                    <Icon icon="circle-plus" />
                  </Button>
                </Col>
              </Row>
            </Form.Group>
          </Form>
          <table className="table tablee4mad">
            <thead>
              <tr>
                <th className="col-10">
                  <FormattedMessage id="Keywords" />
                </th>
                <th className="align-middle text-center tdaction">
                  <FormattedMessage id="Actions" />
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.keywords.map((k, i) => (
                <tr key={i}>
                  <td className="col-10">{k}</td>
                  <td className="text-center">
                    <Button
                      variant="info"
                      onClick={() => this.openKeywordModal(k)}
                    >
                      <Icon icon="pen-to-square" />
                    </Button>
                    <Button
                      variant="danger"
                      className="ml-2"
                      disabled={this.state.keywords.length <= 1}
                      onClick={() =>
                        this.state.keywords.length > 1 &&
                        this.openConfModal(
                          <FormattedMessage id="Warning" />,
                          <FormattedMessage id="Remove.Keyword.Confirmation" />,
                          () => this.deleteKeyword(k),
                        )
                      }
                    >
                      <Icon icon="trash" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {this.state.modal}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="info"
            disabled={
              this.state.keywords.length === 0 ||
              (!family && this.state.file === null) ||
              this.state.keywordError !== ""
            }
            onClick={() => this.addFamily()}
          >
            <FormattedMessage id={family ? "Save.Changes" : "Confirm"} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddProductFamily: (data, successCallback) =>
      dispatch(addProductFamily(data, successCallback)),
    onAddProductFamilyImage: (familyId, data, successCallback) =>
      dispatch(addProductFamilyImage(familyId, data, successCallback)),
    onUpdateProductFamily: (data, successCallback) =>
      dispatch(updateProductFamily(data, successCallback)),
    onGetIsProductFamilyKeywordAlreadyExists: (
      keyword,
      existsCallback,
      noExistsCallback,
    ) =>
      dispatch(
        isProductFamilyKeywordAlreadyExists(
          keyword,
          existsCallback,
          noExistsCallback,
        ),
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(FamilyModal));
